const ProductCardSizeIcon = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM10.75 4H8V5.25H10.75V8H12V5.25V4H10.75ZM5.25 8H4V10.75V12H5.25H8V10.75H5.25V8Z"
      fill="#FE792F"
    />
  </svg>
);

export default ProductCardSizeIcon;
